import React from 'react'

interface QredLogoProps {
    className?: string
}

export default function QredLogo({ className = '' }: QredLogoProps) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2560 1081.92">
            <path
                d="M671.27 550.75h-.5c.1-3.28.5-6.49.5-9.8 0-185.56-150.43-335.99-335.98-335.99s-336 150.44-336 336 150.43 335.99 335.99 335.99c67.85 0 130.88-20.28 183.71-54.87v178.1l152.27 81.74V550.76Zm-152.21-9.79c0 101.5-82.28 183.78-183.77 183.78s-183.78-82.28-183.78-183.78 82.28-183.78 183.78-183.78 183.77 82.28 183.77 183.78ZM2378.83 0l-152.27 81.74v178.1c-52.83-34.59-115.86-54.87-183.71-54.87-185.56 0-335.99 150.43-335.99 335.99s150.43 335.99 335.99 335.99 335.98-150.43 335.98-335.99c0-3.31-.4-6.51-.5-9.8h.5V0Zm-335.98 724.74c-101.5 0-183.78-82.28-183.78-183.78s82.28-183.78 183.78-183.78 183.77 82.28 183.77 183.78-82.28 183.78-183.77 183.78ZM869.17 493.05v383.9H716.9v-383.9c0-186.31 117-284.56 284.56-284.56h26.09v149.83h-28.78c-80.61 0-129.6 49.39-129.6 134.74Z"
                className="fill-[#102c2f] dark:fill-white stroke-0"
            />
            <path
                d="M1671.91 540.96c0-185.56-150.43-335.99-335.99-335.99S999.93 355.4 999.93 540.96s150.43 335.99 335.99 335.99c124.23 0 197.75-23.28 283.28-104.29l-114.84-100.31c-75.49 81.75-290.77 82.46-342.09-71.61l504.03-.02c3.5-19.43 5.62-39.33 5.62-59.76Zm-507.47-75.37c32.59-74.37 99.11-112.73 171.23-112.73s139.82 39.73 171.97 112.73h-343.21Z"
                className="fill-[#102c2f] dark:fill-white stroke-0"
            />
            <circle cx="2466.92" cy="783.86" r="93.08" className="fill-[#102c2f] dark:fill-white stroke-0" />
        </svg>
    )
}
